import { useSearchParams } from "react-router-dom";
import { ShoppingCart, ShoppingBag, Handshake, Store as StoreIcon, Library, Package } from "lucide-react";
import Marketplace from "./Marketplace";
import Store from "./Store";
import Hire from "./Hire";
import SellerStudio from "./SellerStudio";
import BuyerLibrary from "./BuyerLibrary";
import Collection from "./Collection";

// Unified commerce hub — consolidates Marketplace, Store, Hire, Sell, My Purchases & My Collection
// into one "Shop" destination with sub-tabs. Deep-linkable via ?tab=
const TABS = [
  ["marketplace", "Marketplace", ShoppingCart, Marketplace],
  ["store", "Store", ShoppingBag, Store],
  ["hire", "Hire", Handshake, Hire],
  ["sell", "Sell", StoreIcon, SellerStudio],
  ["purchases", "My Purchases", Library, BuyerLibrary],
  ["collection", "My Collection", Package, Collection],
];

export default function Shop() {
  const [sp, setSp] = useSearchParams();
  const active = TABS.some((t) => t[0] === sp.get("tab")) ? sp.get("tab") : "marketplace";
  const Active = (TABS.find((t) => t[0] === active) || TABS[0])[3];
  return (
    <div data-testid="shop-hub">
      <div className="border-b border-white/8 px-4 md:px-6">
        <div className="flex items-center gap-1.5 overflow-x-auto hide-scroll py-3" data-testid="shop-tabs">
          {TABS.map(([key, label, Icon]) => (
            <button key={key} onClick={() => setSp({ tab: key })} data-testid={`shop-tab-${key}`}
              className={`shrink-0 flex items-center gap-1.5 px-4 h-9 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${active === key ? "bg-white text-black" : "surface-2 text-muted-foreground hover:text-white"}`}>
              <Icon size={15} />{label}
            </button>
          ))}
        </div>
      </div>
      <Active />
    </div>
  );
}
